import { TFilterSelected, TREQUEST_REPORT_SUGGESTIONS } from '@monorepo/types';
import { UTILS_GUARDS } from '../ui-filter.guards';
import { UiFilterModifiers } from '../ui-filter.modifier';
import { TFilterGroupModel } from '../ui-filter.types';
import { VIRTUAL_SCROLL_DEFAULT_CONFIG } from './common.model';

export const DATA_VIEW_TABS_FILTER = {
  createModel: (items: TFilterSelected[], prevModel?: TFilterGroupModel<TFilterSelected>) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          hierarchy: item,
          isDisabled: false,
          filteredOrgTree: {
            ...item,
            values: [],
          },
        };
      }
      if (UTILS_GUARDS.isMultiSelectFilter(item)) {
        return {
          type: 'MULTI_SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            ...val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
          ...(item.values.length > VIRTUAL_SCROLL_DEFAULT_CONFIG.itemSize
            ? {
                virtualScroll: VIRTUAL_SCROLL_DEFAULT_CONFIG,
              }
            : {}),
        };
      }
      throw new Error('Type Not suppported');
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
};

export const CREATE_REPORTS_FILTER_MODEL = {
  createModel: (items: TFilterSelected[], prevModel?: TFilterGroupModel<TFilterSelected>) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          searchWithApi: item.searchable
            ? {
                searchEndPoint: 'SEARCH_SUGGESTIONS_BCTX',
                searchService: 'reports-v2',
                payload: undefined,
              }
            : undefined,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.values.length > 100
            ? {
                virtualScroll: {
                  itemSize: 40,
                  minBufferPx: window.screen.height / 2,
                  maxBufferPx: window.screen.height / 2,
                },
              }
            : {}),
        };
      }

      if (UTILS_GUARDS.isMultiSelectFilter(item)) {
        return {
          type: 'MULTI_SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            ...val,
            isSelected: false,
          })),
          selectedValues: [],
          ...(item.version ? { version: item.version } : {}),
          ...(item.values.length > 100
            ? {
                virtualScroll: {
                  itemSize: 40,
                  minBufferPx: window.screen.height / 2,
                  maxBufferPx: window.screen.height / 2,
                },
              }
            : {}),
        };
      }

      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          hierarchy: item,
          isDisabled: false,
          filteredOrgTree: {
            ...item,
            values: [],
          },
          ...(item.version ? { version: item.version } : {}),
        };
      }

      if (UTILS_GUARDS.isSingleSelectFilter(item)) {
        return {
          type: 'SINGLE_SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values,
          selectedValue: undefined,
          inputLabel: item.displayName,
        };
      }

      throw new Error('Type Not suppported');
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
  addPayload: (
    model: TFilterGroupModel<TFilterSelected>,
    payload: TREQUEST_REPORT_SUGGESTIONS,
  ): TFilterGroupModel<TFilterSelected> => {
    return {
      ...model,
      groups: model.groups.map((groupItem) => {
        switch (groupItem.type) {
          case 'SELECT_FILTER':
            return {
              ...groupItem,

              searchWithApi: groupItem.searchWithApi
                ? {
                    searchEndPoint: 'SEARCH_SUGGESTIONS_BCTX',
                    searchService: 'reports-v2',
                    payload: payload,
                  }
                : undefined,
            };
          default:
            return groupItem;
        }
      }),
    };
  },

  checkIfAllFiltersSelected: (model: TFilterGroupModel<TFilterSelected>): boolean => {
    const allGroupSelection = model.groups.map((groupItem) => {
      switch (groupItem.type) {
        case 'SELECT_FILTER':
          return groupItem.selectedValues.length > 0 ? true : false;
        case 'SINGLE_SELECT_FILTER':
          return groupItem.selectedValue ? true : false;
        case 'MULTI_SELECT_FILTER':
          return groupItem.selectedValues.length > 0 ? true : false;
        default:
          return true;
      }
    });

    return allGroupSelection.reduce((pV, cV) => {
      return pV && cV;
    }, true);
  },
};
